// extracted by mini-css-extract-plugin
export default {"wrapper":"bXM75akksy8QtRyc4ObC","container":"dPmNIJVQ4OzGvF4y8hb0","title":"KMDjB9hx19myKFkxXI22","subtitle":"aA0UuRbTJoJeu_Jf2GgF","actions":"Y64jjTTiO9EmD9KDsHeF"};